// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"579":"9c1d7b9c","643":"65e58364"}[chunkId] + ".chunk.js";
};